<template>
  <div>
    <div class="chooseTab">
      <ul>
        <li :class="data_type === 'cumulative' ? 'tabLCur' : ''"><a href="javascript:;" @click="data_type = 'cumulative';draw()">累计</a></li>
        <li :class="data_type === 'month' ? 'tabLCur' : ''"><a href="javascript:;" @click="data_type = 'month';draw()">单{{ time_text }}</a></li>
      </ul>
    </div>
    <div
      class="markBox"
      id="bar-yoy"
      :style="{ width: width + 'px', height: height + 'px' }"
    ></div>
  </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
require("echarts/lib/component/legend");
require("echarts/lib/component/tooltip");

export default {
  name: "bar-yoy",
  props: {
    volume_data: Array,
    width: Number,
    height: Number,
    is_loading: Boolean,
    time_type: String
  },
  data() {
    return {
      chart: {},
      time_text:"月",
      data_type: "cumulative"
    };
  },
  watch: {
    volume_data(new_val) {
      this.chart.showLoading();
      this.volume_data = new_val;
      this.draw();
    },
    is_loading(new_val) {
      new_val ? this.chart.showLoading() : this.chart.hideLoading();
    },
    time_type(new_val){
      switch(new_val){
        case "quarter":
          this.time_text = "季";
          break;
        case "year":
          this.time_text = "年";
          break;
        case "month":
        default:
          this.time_text = "月";
          break;
      }
    }
  },
  mounted() {
    this.chart = echarts.init(document.getElementById("bar-yoy"));
    this.chart.showLoading();
    switch(this.time_type){
        case "quarter":
          this.time_text = "季";
          break;
        case "year":
          this.time_text = "年";
          break;
        case "month":
        default:
          this.time_text = "月";
          break;
      }
  },
  methods: {
    draw() {

      const _this = this;
      const data = JSON.parse(JSON.stringify(_this.volume_data));
      if (null == data || "undefined" == typeof data || "" == data) {
        this.chart.hideLoading();
        this.chart.setOption({xAxis: {type: 'category',data: ['暂无数据']},yAxis: {type: 'value'}}, true);
        return;
      }
      
      // 累计
      if(this.data_type === "cumulative"){
        data.forEach(function (item,index) {
            if(index > 0){
                item.volume += data[index - 1].volume;
                item.lastVolume += data[index - 1].lastVolume;
            }
        });
        data.forEach(function (item) {
            item.yoy = item.lastVolume === 0 ? '-' 
                : parseFloat(((item.volume - item.lastVolume) / item.lastVolume * 100).toFixed(2));
        });
      }

      let xAxisData = [];
      let thisData = [];
      let lastData = [];
      let yoyData = [];
      let seriesData = [];

      xAxisData = Array.from(
        new Set(
          data.map(function (x) {
            return x.date;
          })
        )
      );

      data.forEach(function (item) {
        thisData.push(item.volume);
        lastData.push(item.lastVolume);
        yoyData.push(item.yoy);
      });
      seriesData.push(
        {
          name: "去年同期",
          type: "bar",
          yAxisIndex: 0,
          barWidth: 12,
          barCategoryGap: 30,
          data: lastData,
          // label: {
          //     show: true,
          //     position: 'top',
          //     // formatter: (param => param.value.toLocaleString())
          // },
        },
        {
          name: "当前",
          type: "bar",
          yAxisIndex: 0,
          barWidth: 12,
          barCategoryGap: 30,
          data: thisData,
        },
        {
          name: "同比",
          type: "line",
          smooth: true,
          yAxisIndex: 1,
          data: yoyData,
          label: {
              show: true,
              position: 'top',
              formatter: (param => param.value + '%')
          },
        }
      );

      let thisDataMax = _this.getMaxAxis(_this.getMaxValue(thisData));
      let lastDataMax = _this.getMaxAxis(_this.getMaxValue(lastData));
      let yoyMin = _this.getMinValue(yoyData);
      let yoyMax = _this.getMaxValue(yoyData);

      let y1Max = thisDataMax > lastDataMax ? thisDataMax : lastDataMax;

      var option = {
        color: ["#C3C3C3", "#00578F", "#5D7092", "#5D7092"],
        grid: [{ y: "10%", }],
        legend: {
          bottom: 1,
          left: "center",
          padding: [20, 52, 20, 52],
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: (params) => {
            let list = [];
            if(params && params.length > 0)
            {
              list.push('<span style="font-size:12px;color:#6e7079;margin-left:2px">' + params[0]?.name + '</span><div style="clear:both"></div>')
            }
            let listItem = "";
            for (let param of params) {
              list.push(
                param.marker +
                  '<span style="display:inline-block;font-size:12px;color:#6e7079;margin-left:2px;width:55px;">' +
                    param.seriesName
                  +
                  '</span>：' +
                  '<span style="font-size:12px;margin-left:5px;">' +
                    param.value.toLocaleString() +
                  "</span>" +
                  '<div style="clear:both"></div>'
              );
            }
            listItem = list.join("");
            return listItem;
          },
        },
        xAxis: [
          {
            type: "category",
            data: xAxisData,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "（辆）",
            min: 0,
            max: (y1Max * 1.1),
            splitNumber: 5,
            interval: parseInt((y1Max * 1.1) / 5),
          },
          {
            type: "value",
            name: "同比",
            axisLabel: {
              show: true,
              interval: "auto",
              formatter: "{value} %",
            },
            min: _this.getMinMaxY2(yoyMin, yoyMax) * -5,
            max: _this.getMinMaxY2(yoyMin, yoyMax),
            splitNumber: 5,
            interval: parseInt(
              (_this.getMinMaxY2(yoyMin, yoyMax) -
                _this.getMinMaxY2(yoyMin, yoyMax) * -5) /
                5
            ),
          },
        ],
        series: seriesData,
      };
      
      this.chart.on('legendselectchanged', function(obj) { 
        console.log(obj)
      })
      this.chart.clear();
      this.chart.setOption(option, true);
      this.chart.hideLoading();
    },
    getMaxValue(arr) {
      var arrCopy = arr.slice(0);
      for (var i = arrCopy.length; i >= 0; i--) {
        if (!(typeof arrCopy[i] == "number")) {
          arrCopy.splice(i, 1);
        }
      }
      const max = Math.max.apply(null, arrCopy);
      return Math.ceil(max / 9.5) * 10;
    },
    getMinValue(arr) {
      var arrCopy = arr.slice(0);
      for (var i = arrCopy.length; i >= 0; i--) {
        if (!(typeof arrCopy[i] == "number")) {
          arrCopy.splice(i, 1);
        }
      }
      const min = Math.min.apply(null, arrCopy);
      return Math.floor(min / 10) * 10;
    },
    getMaxAxis(m) {
      let singleLine = Math.pow(10, m.toString().length - 2) * 5;
      let maxLine = singleLine * (parseInt(m / singleLine) + 1);
      return maxLine;
    },
    getMinMaxY2(min, max) {
      let mabs = Math.abs(max) > Math.abs(min) ? Math.abs(max) : Math.abs(min);
      let maxLine = parseInt((mabs + 10) / 10) * 10;
      return maxLine;
    }
  },
};
</script>
